export default __webpack_public_path__ + "static/media/tarjetas-de-credito.1f62aa2b.svg";